import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const withRouter = (Component : any) => {
    const Wrapper = (props : any) => {
        const navigate = useNavigate();
        const location = useLocation();
        const params = useParams();

        // @ts-ignore
        return (
            <Component
                navigate={navigate}
                location={location}
                params={params}
                {...props}
            />
        );
    };

    return Wrapper;
};